// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { hasChanged } from '../../utils/react/propsComparisons';

const dragOriginHasChanged = hasChanged('dragOrigin');
const dragModifierKeysHaveChanged = hasChanged('dragModifierKeys');

// Makes the hover effects move towards the cursor
const getHoverTransformOrigin = (props) => {
    const { dragOrigin } = props;
    return {
        transformOrigin: dragOrigin ? `${dragOrigin.x}px ${dragOrigin.y}px` : null,
    };
};

class HoverTransformTarget extends React.Component {
    shouldComponentUpdate(nextProps) {
        return dragOriginHasChanged(this.props, nextProps) || dragModifierKeysHaveChanged(this.props, nextProps);
    }

    render() {
        return (
            <div className="HoverTransformTarget" style={getHoverTransformOrigin(this.props)}>
                {this.props.children}
            </div>
        );
    }
}

HoverTransformTarget.propTypes = {
    dragOrigin: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default HoverTransformTarget;
